import { CommonModule } from '@angular/common';
import { Component, computed, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
	faAngleDown,
	faDownload,
	faHourglass,
	faHourglass1,
	faHourglass2,
	faHourglassEnd,
	faQuestionCircle,
	faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { ModalComponent } from 'src/app/page_component_item/modal/modal.component';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { SessionStatus } from 'src/app/services/profile/sessionStatus.enum';
import { logInterface } from 'src/app/util/interfaces/log.interface';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { RequestPageTabAcompanhamentoService } from './data/request-page-tab-acompanhamento.service';
import { statusInterface } from 'src/app/util/interfaces/statusInterface';
import { requestInterface } from 'src/app/util/interfaces/request';
import { InfoAlertComponent } from 'src/app/page_component_item/info-alert/info-alert.component';
import { MspPipesModule } from 'src/app/util/pipes/msp-pipes.module';
import { DateService } from 'src/app/services/date/date.service';
import { PermissionService } from 'src/app/util/services/permission/permission.service';
import { FilesService } from 'src/app/services/files/files.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { FormsModule } from '@angular/forms';
import { DotBounceLoadingEffectComponent } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.component';
import { CheckboxComponent } from 'src/app/page_component_item/checkbox/checkbox.component';
import { CustomerStrikeService } from 'src/app/page/register-page/register-forms/request/customer-strike/service/customer-strike.service';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { mimeTypeInterface } from 'src/app/util/interfaces/mimeTypeInterface';
import { MspButtonComponent } from 'src/app/page_component_item/msp-button/msp-button.component';
import { mspFileInterface } from 'src/app/util/interfaces/mspFile';

@Component({
	selector: 'pcp-request-page-tab-acompanhamento',
	standalone: true,
	imports: [
		CommonModule,
		FontAwesomeModule,
		InfoAlertComponent,
		MspPipesModule,
		FormsModule,
		ModalComponent,
		DotBounceLoadingEffectComponent,
		CheckboxComponent,
		MspButtonComponent,
	],
	templateUrl: './request-page-tab-acompanhamento.component.html',
	styleUrl: './request-page-tab-acompanhamento.component.scss',
})
export class RequestPageTabAcompanhamentoComponent implements OnInit {
	private readonly requestPageTabAcompanhamentoService = inject(RequestPageTabAcompanhamentoService);
	private readonly labelsService = inject(LabelsService);
	private readonly profileService = inject(ProfileService);
	private readonly filesService = inject(FilesService);
	private readonly notificationService = inject(NotificationService);
	private readonly customerStrikeService = inject(CustomerStrikeService);
	public readonly dateService = inject(DateService);
	public readonly permissionService = inject(PermissionService);

	@ViewChild('logModal') logModal: ModalComponent;

	icons = {
		faAngleDown: faAngleDown,
		faDownload: faDownload,
		faQuestionCircle: faQuestionCircle,
		faHourglass: faHourglass,
		faHourglass1: faHourglass1,
		faHourglass2: faHourglass2,
		faHourglassEnd: faHourglassEnd,
		faTrash: faTrash,
	};
	labels: LabelsInterface;
	private readonly logEmailInfoRegex = /<div class="log-email-info">([\S\s]*?)<\/div>/i;

	constructor() {
		this.labels = computed(() => this.labelsService.labels())();
	}

	isSecondaryLogButtonOpen = false;
	reactivationRequestButton = false;

	userView = this.profileService.userData().sessionStatus;
	userViewTypes = SessionStatus;

	sendEmailEnduser = false;

	newLog: logInterface;
	isSuperEditingLog = false;
	newSuperLog: logInterface;
	isSendingLog = false;

	allowedMimeTypes: mimeTypeInterface[] = [];
	allowedMimeTypeStr = '';
	allowedMimeTypeTip = '';

	isLoadingAvailableStatus = true;
	isLoadingAllStatus = true;
	availableStatus: statusInterface[] = [{ status: 'New', label: 'New' }];
	allStatus: statusInterface[] = [];
	allStatusAsLabel: { [status: string]: string } = {};

	@Input() requestData: requestInterface;
	@Output() requestDataChanged = new EventEmitter<requestInterface>();
	@Input() requestDataMemory: requestInterface;
	@Output() requestDataMemoryChanged = new EventEmitter<requestInterface>();
	@Input() isRequestBeingEdited: boolean;
	@Output() isRequestBeingEditedChanged = new EventEmitter<boolean>();

	isModalExpanded = false;
	enable3strikes: number;
	applyStrike = false;
	closeChildRequests = false;

	availableEmailCCUsersIAC: iacOptionInterface[] = [];
	selectedEmailCCUserIAC: iacOptionInterface = { name: '', value: '' };

	currentTimerIcon = this.icons.faHourglass;
	timerTime = { hour: 0, minute: 0 };
	timerString = '';
	startTimer = false;
	cronTimer: NodeJS.Timeout;
	cronIcon: NodeJS.Timeout;

	ngOnInit(): void {
		throw 'O componenente de aba de chamadon não está em uso';
		this.setNewLog();

		this.requestPageTabAcompanhamentoService.getAvailableStatus(this.requestData.id).subscribe({
			next: (availableStatus) => {
				this.availableStatus = availableStatus;
				this.isLoadingAvailableStatus = false;
			},
		});

		this.requestPageTabAcompanhamentoService.getAllStatus().subscribe({
			next: (allStatus) => {
				this.allStatus = allStatus;
				for (const status of this.allStatus) {
					this.allStatusAsLabel[status.status] = status.label;
				}
				this.isLoadingAllStatus = false;
			},
		});

		this.customerStrikeService.getStrikeCustomer().subscribe((strikes) => {
			this.enable3strikes = strikes[0].enable_3strikes;
		});
	}

	setNewLog() {
		this.newLog = {
			analyst: '',
			duration: '',
			idLog: '',
			log_date: '',
			notes: '',
			status: '',
			overdueReason: '',
			email_cc: '',
			file_log: [],
			sendEmailAttachEnduser: false,
		};

		this.newSuperLog = { ...this.newLog };
	}

	formatDuration(dateString: string): string {
		const date = new Date(dateString);
		let formatedDate = '';

		if (date.getHours() <= 9) {
			formatedDate += '0';
		}
		formatedDate += date.getHours() + 'h';
		if (date.getMinutes() <= 9) {
			formatedDate += '0';
		}
		formatedDate += date.getMinutes() + 'm';

		return formatedDate;
	}

	formatAttachPath(filePath: string): string {
		if (filePath) {
			let splitedFilePath = [];
			splitedFilePath = filePath.includes('\\') ? filePath.split('\\') : filePath.split('/');

			return splitedFilePath.at(-1);
		}

		return '';
	}

	downloadFile(filePath: string): void {
		filePath = this.formatAttachPath(filePath);
		this.requestPageTabAcompanhamentoService.getFile(filePath).subscribe(
			(mspFile) => {
				this.filesService.downloadFile(this.filesService.fileFromBase(mspFile, 'Base64'));
			},
			(error) => {
				this.notificationService.setNotificationMessage(this.labels.lbl_rep_custom_arquivo_nao_encontrado);
			}
		);
	}

	getLogPrimaryNotes(notes: string): string {
		if (!notes) return '';

		return notes
			.replace(this.logEmailInfoRegex, '')
			.replaceAll(/(<br\s*\/?>\s*)+$/gi, '')
			.trim();
	}

	getLogInfoNote(notes: string): string {
		if (!notes) return '';

		const match = notes.match(this.logEmailInfoRegex);
		return match ? match[1].trim() : '';
	}

	formatDateToValue(dateString: string): string {
		const date = new Date(dateString);
		let formatedDate = '';
		formatedDate += date.getFullYear() + '-';

		if (date.getMonth() + 1 <= 9) {
			formatedDate += '0';
		}
		formatedDate += date.getMonth() + 1 + '-';

		if (date.getDate() <= 9) {
			formatedDate += '0';
		}
		formatedDate += date.getDate();

		return formatedDate;
	}

	resetSuperLog(): void {
		this.newSuperLog = {
			analyst: '',
			duration: '',
			idLog: '',
			log_date: '',
			notes: '',
			status: '',
			overdueReason: '',
		};
	}

	setNewSuperLog(log: logInterface): void {
		this.newSuperLog = $.extend(true, {}, log);
	}

	superUpdateLog(idLog: string): void {
		const superLogMemory = $.extend(true, {}, this.newSuperLog);
		const durationRegex = new RegExp(String.raw`^\d\d:\d\d$`);
		if (superLogMemory.duration != '00:00' && durationRegex.test(superLogMemory.duration)) {
			superLogMemory.duration =
				'' +
				new Date().getFullYear() +
				'-' +
				(new Date().getMonth() + 1) +
				'-' +
				new Date().getDate() +
				' ' +
				superLogMemory.duration;
		}
		let logMemory: logInterface;
		for (const [index, log] of this.requestData.logs.entries()) {
			if (log.idLog === idLog) {
				logMemory = $.extend(true, {}, this.requestData.logs[index]);
				this.requestData.logs[index] = superLogMemory;
			}
		}

		this.isSuperEditingLog = false;
		this.resetSuperLog();

		this.requestPageTabAcompanhamentoService.superUpdateLog(superLogMemory).subscribe(
			() => {},
			() => {
				for (const [index, log] of this.requestData.logs.entries()) {
					if (log.idLog === idLog) {
						this.requestData.logs[index] = logMemory;
					}
				}
				this.notificationService.setNotificationMessage('* Houve um erro na atualização de log.');
			}
		);
	}

	formatTimer() {
		if (this.newLog.duration.length === 0) {
			this.newLog.duration = '';
		} else if (this.newLog.duration.length == 1) {
			this.newLog.duration = `00:0${this.newLog.duration}`;
		} else if (this.newLog.duration.length == 2) {
			this.newLog.duration = `00:${this.newLog.duration}`;
		}

		if (this.newLog.duration.length == 5) {
			const [inputHoras, inputMinutos] = this.newLog.duration.split(':').map(Number);
			this.timerTime.hour = inputHoras;
			this.timerTime.minute = inputMinutos;

			if (this.timerTime.hour > 23) {
				this.timerTime.hour = 23;
				this.timerTime.minute = 59;
				this.notificationService.setNotificationMessage(this.labels.lbl_maximo_duracao);
			}

			this.timerTime.minute = this.timerTime.minute > 59 ? 59 : this.timerTime.minute;

			if (this.timerTime.minute < 10 && this.timerTime.hour < 10) {
				this.timerString = `0${this.timerTime.hour}:0${this.timerTime.minute}`;
			} else if (this.timerTime.minute < 10) {
				this.timerString = `${this.timerTime.hour}:0${this.timerTime.minute}`;
			} else if (this.timerTime.hour < 10) {
				this.timerString = `0${this.timerTime.hour}:${this.timerTime.minute}`;
			} else {
				this.timerString = `${this.timerTime.hour}:${this.timerTime.minute}`;
			}

			this.newLog.duration = this.timerString;
		}
	}

	countRequestDuration(value: any): void {
		this.newLog.duration == '' ? (this.newLog.duration = '00:01') : (this.newLog.duration = value);

		const [inputHoras, inputMinutos] = this.newLog.duration.split(':').map(Number);
		this.timerTime.hour = inputHoras;
		this.timerTime.minute = inputMinutos;

		if (this.startTimer) {
			this.stopRequestDuration();
		} else {
			clearInterval(this.cronTimer);
			this.startTimer = true;

			this.cronIcon = setInterval(() => {
				switch (this.currentTimerIcon) {
					case this.icons.faHourglass: {
						this.currentTimerIcon = this.icons.faHourglass1;

						break;
					}
					case this.icons.faHourglass1: {
						this.currentTimerIcon = this.icons.faHourglass2;

						break;
					}
					case this.icons.faHourglass2: {
						this.currentTimerIcon = this.icons.faHourglassEnd;

						break;
					}
					default: {
						this.currentTimerIcon = this.icons.faHourglass;
					}
				}
			}, 1500);

			this.cronTimer = setInterval(() => {
				this.timerTime.minute++;

				if (this.timerTime.minute == 60) {
					this.timerTime.hour++;
					this.timerTime.minute = 0;
				}

				if (this.timerTime.minute < 10 && this.timerTime.hour < 10) {
					this.timerString = `0${this.timerTime.hour}:0${this.timerTime.minute}`;
				} else if (this.timerTime.minute < 10) {
					this.timerString = `${this.timerTime.hour}:0${this.timerTime.minute}`;
				} else if (this.timerTime.hour < 10) {
					this.timerString = `0${this.timerTime.hour}:${this.timerTime.minute}`;
				} else {
					this.timerString = `${this.timerTime.hour}:${this.timerTime.minute}`;
				}

				this.newLog.duration = this.timerString;
			}, 60_000);
		}
	}

	stopRequestDuration() {
		clearInterval(this.cronTimer);
		clearInterval(this.cronIcon);
		this.newLog.duration = this.newLog.duration;
		this.startTimer = false;
		this.currentTimerIcon = this.icons.faHourglass;
		this.formatTimer();
	}

	isLimitDateOver(): boolean {
		return new Date() > new Date(this.requestData.limit_date);
	}

	handleFileLog(index?: number): void {
		const logFile = (<HTMLInputElement>document.querySelector('#logFile')).files;
		if (index == undefined) {
			Array.prototype.forEach.call(logFile, (file: File) => {
				if (!this.filesService.nameAllowed(file)) {
					return this.notificationService.setNotificationMessage(this.labels.lbl_geral_nomes_arquivos_caracteres_especiais);
				}

				this.filesService.MSPFileFromFile(file).then((mspFile) => {
					for (let index_ = 0; index_ < this.newLog.file_log.length; index_++) {
						const logFile = this.newLog.file_log[index_];
						if (logFile.content != mspFile.content) continue;

						this.notificationService.setNotificationMessage(this.labels.lbl_arquivo_adicionado);
						return;
					}
					if (Math.floor(mspFile.size / 1_000_000) > this.allowedMimeTypes[0].max_file_size) {
						this.notificationService.setNotificationMessage(
							`"${mspFile.name}" ${this.labels.lbl_limite_tamanho_excedido} ${Math.floor(this.allowedMimeTypes[0].max_file_size)}MB.`
						);
					} else if (mspFile.mimeType == '' || !this.allowedMimeTypeStr.includes(mspFile.mimeType)) {
						this.notificationService.setNotificationMessage(
							`"${mspFile.name}" ${this.labels.lbl_formato_invalido_ou_corrompido}`
						);
					} else {
						this.newLog.file_log.push(mspFile);
					}
				});
			});
		} else {
			this.newLog.file_log.splice(index, 1);
		}
	}

	addLog(): void {
		// if (this.isSendingLog) return;
		// //Não permitir adicionar log caso chamado esteja sendo editado. Pode ocasionar erros onde salva campos obrigatórios em branco
		// if (this.isRequestBeingEdited) {
		// 	return this.notificationService.setNotificationMessage(this.labels.lbl_geral_unsaved_changes_form);
		// }
		// let durationRegex = new RegExp('^[0-9][0-9]:[0-9][0-9]$');
		// let emailRegex = new RegExp('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$');
		// let emailListRegex = new RegExp(
		// 	'^\\s*([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,})(\\s*[;,]\\s*[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,})*\\s*$'
		// );
		// this.verifyCustomfieldValues();
		// const isEmptyStatus = this.newLog.status.trim() === '';
		// const isSolvedStatus = this.newLog.status === 'Solved';
		// const isOverdueIncident = isSolvedStatus && this.requestData.service_type === 'Incident' && this.isLimitDateOver();
		// //condição para analysts
		// if (this.userView === this.userViewTypes.ANALYST) {
		// 	if (isEmptyStatus) {
		// 		return this.notificationService.setNotificationMessage(this.labels.lbl_por_favor_selecione_status);
		// 		//chamado não pode ser encerrado caso tenha campos customizados obrigatórios vazios
		// 	} else if (isSolvedStatus && !this._isCustomfieldFulfilled) {
		// 		this._isCustomfieldFulfilled = true;
		// 		return this.notificationService.setNotificationMessage(this.labels.lbl_geral_preencha_campo_obrigatorio);
		// 		//informar motivo do atraso de encerramento do chamado
		// 	} else if (isOverdueIncident && this.newLog.overdueReason.trim() === '') {
		// 		return this.notificationService.setNotificationMessage(this.labels.lbl_motivo_atraso);
		// 		//log sem tempo de duração
		// 	} else if (this.newLog.duration.trim() === '' || !durationRegex.test(this.newLog.duration)) {
		// 		return this.notificationService.setNotificationMessage(this.labels.lbl_preencha_duracao);
		// 	} else if (this.requestData.service_type === 'Change' && this.newLog.status === 'Solved') {
		// 		this.validateDatesChange();
		// 		if (this.isDatesChangePlanMissing)
		// 			return this.notificationService.setNotificationMessage(this.labels.lbl_geral_preencher_datas_plano_para_fechar);
		// 	}
		// 	//condição para endusers
		// } else if (this.userView === this.userViewTypes.ENDUSER && this.hasMatchingActiveGroup === false) {
		// 	this.newLog.status = 'Enduser Feedback';
		// }
		// this.RequestPageService.getRequest(this.requestData.id).subscribe((requestRes) => {
		// 	if (this.newLog.notes.trim() === '') {
		// 		this.notificationService.setNotificationMessage(this.labels.lbl_insert_commentary_to_publish_log);
		// 	} else if (
		// 		requestRes.active == '0' &&
		// 		!['Enduser Feedback', 'Internal Comment', 'Re-Activate'].includes(this.newLog.status) &&
		// 		requestRes.status == 'Solved'
		// 	) {
		// 		this.notificationService.setNotificationMessage(this.labels.lbl_chamado_ja_fechado);
		// 	} else if (requestRes.active == '1' && ['Re-Activate'].includes(this.newLog.status)) {
		// 		this.notificationService.setNotificationMessage(this.labels.lbl_chamado_ja_aberto);
		// 	} else {
		// 		// this.NotificationService.setNotificationMessage(this.labels.lbl_log_publicada);
		// 		this.isSendingLog = true;
		// 		let resolvedEmailCC = '';
		// 		let typedEmailCC = (this.selectedEmailCCUserIAC.name || '').trim();
		// 		this.newLog.email_cc = '';
		// 		if (this.selectedEmailCCUserIAC.value == this.selectedEmailCCUserIAC.name) {
		// 			resolvedEmailCC = '' + this.selectedEmailCCUserIAC.value;
		// 		} else if (typedEmailCC && emailListRegex.test(typedEmailCC)) {
		// 			resolvedEmailCC = typedEmailCC
		// 				.split(/[;,]/)
		// 				.map((email) => email.trim())
		// 				.filter((email) => emailRegex.test(email))
		// 				.join(',');
		// 		} else if (typedEmailCC) {
		// 			this.isSendingLog = false;
		// 			return this.notificationService.setNotificationMessage('Informe um e-mail válido para cópia.');
		// 		}
		// 		this.newLog.email_cc = resolvedEmailCC;
		// 		this.RequestPageService.addLog(this.requestData.id, this.newLog).subscribe({
		// 			next: (logRes: logInterface) => {
		// 				if (logRes.analyst != this.requestData.email_analyst && this.newLog.status === 'Solved' && this.userView === this.userViewTypes.ANALYST) {
		// 					this.requestData.id_analyst = this.profileService.userData().idAnalyst;
		// 					this.saveRequestChanges();
		// 				}
		// 				this.isLoadingAvailableStatus = true;
		// 				this.RequestPageService.getAvailableStatus(this.requestData.id).subscribe((availableStatus) => {
		// 					this.availableStatus = availableStatus;
		// 					this.isLoadingAvailableStatus = false;
		// 				});
		// 				this.requestData.duration =
		// 					parseInt(this.requestData.duration.toString()) +
		// 					new Date(logRes.duration).getHours() * 60 +
		// 					new Date(logRes.duration).getMinutes();
		// 				let newLog: logInterface = {
		// 					idLog: logRes.idLog,
		// 					log_date: logRes.log_date,
		// 					notes: logRes.notes,
		// 					status: logRes.status,
		// 					duration: logRes.duration,
		// 					analyst: logRes.analyst,
		// 					overdueReason: ('' + this.newLog.overdueReason).slice(0),
		// 					file_log: [],
		// 				};
		// 				this.newLog.file_log.forEach((file) => {
		// 					let tmpFile: mspFileInterface = {
		// 						content: '',
		// 						checkSum: '',
		// 						extension: '',
		// 						file_path: '...',
		// 						mimeType: '',
		// 						name: '',
		// 						size: 0,
		// 					};
		// 					newLog.file_log.push(tmpFile);
		// 				});
		// 				let tmpAvailableEmailCCUsersIAC = [...this.availableEmailCCUsersIAC];
		// 				this.availableEmailCCUsersIAC = [];
		// 				setTimeout(() => {
		// 					this.availableEmailCCUsersIAC = tmpAvailableEmailCCUsersIAC;
		// 					this.selectedEmailCCUserIAC = { name: '', value: '' };
		// 				}, 0);
		// 				if (this.newLog.file_log.length > 0) {
		// 					this.RequestPageService.sendAttach(logRes.idLog, this.newLog.file_log).subscribe((fileMspRes) => {
		// 						this.requestData.logs.forEach((log) => {
		// 							if (log.idLog === 'NEW' || log.idLog.toString() == logRes.idLog.toString()) {
		// 								log.file_log = fileMspRes;
		// 								return;
		// 							}
		// 						});
		// 					});
		// 				}
		// 				if (this.newLog.status == 'Solved' && this.closeChildRequests == true) {
		// 					this.RequestPageService.closeChildRequest(this.requestData.id).subscribe();
		// 				}
		// 				const insertedLog = $.extend(true, {}, newLog);
		// 				this.requestData.logs.unshift(insertedLog);
		// 				if (this.newLog.status != 'Internal Comment' && this.sendEmailEnduser) {
		// 					this.RequestPageService.sendLogEmailEnduser(logRes.idLog, resolvedEmailCC).subscribe(
		// 						(sendResp: any) => {
		// 							if (sendResp?.forwardedEmailLogNote) {
		// 								const currentLog = this.requestData.logs.find(
		// 									(log) => log.idLog?.toString() === logRes.idLog?.toString()
		// 								);
		// 								if (currentLog) {
		// 									currentLog.notes = `${currentLog.notes}${sendResp.forwardedEmailLogNote}`;
		// 								} else {
		// 									insertedLog.notes = `${insertedLog.notes}${sendResp.forwardedEmailLogNote}`;
		// 								}
		// 							}
		// 						}
		// 						// , error => {
		// 						//   this.NotificationService.setNotificationMessage(error.error.Message);
		// 						// }
		// 					);
		// 				}
		// 				if (
		// 					this.userView === this.userViewTypes.ANALYST &&
		// 					this.newLog.status != 'Internal Comment' &&
		// 					this.newLog.status != 'Custom Field Update'
		// 				)
		// 					this.requestData.status = ('' + this.newLog.status).slice(0);
		// 				if (this.newLog.status === 'Cancelled' || this.newLog.status === 'Solved') {
		// 					this.resetRequest();
		// 					this.isRequestBeingEdited = false;
		// 				}
		// 				if (this.newLog.status === 'Re-Activate') {
		// 					if (this.requestData.tasks.length > 0) {
		// 						this.requestData.tasks.forEach((task, index) => {
		// 							if (task.task_status === 'Rejected') {
		// 								this.newTask = $.extend(true, {}, task);
		// 								this.newTask.task_status = 'Re-Activate';
		// 								this.updateTask(this.newTask.id_task, index);
		// 							}
		// 						});
		// 					} else {
		// 						this.requestData.status = 'In Progress';
		// 					}
		// 				}
		// 				this.newLog = {
		// 					analyst: '',
		// 					duration: '',
		// 					idLog: '',
		// 					log_date: '',
		// 					notes: '',
		// 					status: this.newLog.status,
		// 					overdueReason: '',
		// 					file_log: [],
		// 				};
		// 				this.stopRequestDuration();
		// 				this.updateCountStrike(false);
		// 				this.isModalOpen = false;
		// 				this.isSendingLog = false;
		// 				this.notificationService.setNotificationMessage(this.labels.lbl_log_publicada);
		// 				if (this.requestData.status === 'Waiting User' && this.availableEmailStatus[0].Email_WaitingUser === 0) {
		// 					this.notificationService.setNotificationMessage(this.labels.lbl_envio_email_desabilitado);
		// 				}
		// 			},
		// 			complete: () => {
		// 				this.reactivationRequestButton = false;
		// 				this.newLog.status = '';
		// 				this.closeChildRequests = false;
		// 			},
		// 		});
		// 	}
		// });
	}
}
